import React from 'react';
import Image from 'next/image';
import { NoAnswersProps } from 'views/Questions/components/NoAnswers/NoAnswers.types';
import styles from './NoAnswers.module.css';

const NoAnswers = ({ type, setUserWriteAnswer, isAuthor }: NoAnswersProps) => {
  return (
    <div className={styles.no_question}>
      <div className={styles.no_question__img_wrapper}>
        {type === 'confirmed' || type === 'moderating' ? (
          <Image
            alt=""
            src="https://static.uchi.ru/files/otvety/no_answers_icon.svg"
            width={100}
            height={100}
          />
        ) : (
          <div className={styles.no_question__declined_icon} />
        )}
      </div>
      {(type === 'confirmed' && isAuthor) || (type === 'moderating' && isAuthor) ? (
        <span className={styles.no_question__text}>Еще немного и тут будут ответы!</span>
      ) : type === 'declined' && isAuthor ? (
        <span
          className={`${styles.no_question__text} ${styles.no_question__text_declined}`}
        >
          Мы не размещаем вопросы, которые:
          <ul className={styles.no_question__list}>
            <li>повторяют уже опубликованные;</li>
            <li>содержат брань и нецензурную лексику;</li>
            <li>состоят из одних символов;</li>
            <li>не соответствуют указанному предмету;</li>
            <li>
              отсылают к картинкам/страницам учебника, которые невозможно посмотреть.
            </li>
          </ul>
        </span>
      ) : (
        <span className={styles.no_question__text}>
          Будь первым, кто{' '}
          <span
            onClick={() => (setUserWriteAnswer ? setUserWriteAnswer(true) : null)}
            className={styles.underline}
          >
            ответит на вопрос
          </span>
        </span>
      )}
    </div>
  );
};

export default NoAnswers;
